if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    checkQty(prodId, qty ,maxQty){
      let qtyMessage = window.cartStrings.maxLimitReached.replace('[quantity]', maxQty)
      const submitButton = this.querySelector('[type="submit"]');
      let isQtyLimited = () =>   {
        this.handleErrorMessage(qtyMessage);
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('qty-limited');
      }
      if (qty === maxQty){
        isQtyLimited();
      }
      if (qty  > maxQty){
        disableGlobalCheckout();
        isQtyLimited();
      }
    }
    updateCartItems(prodId, qty){
      for (const itemId in window.finalCartItems) {
        if (prodId in window.finalCartItems) {
          window.finalCartItems[prodId] = window.finalCartItems[prodId] + qty;
          return this.checkQty(prodId, window.finalCartItems[prodId], window.limitedQtyProducts[prodId]);
        }
      }
      if(!(prodId in window.finalCartItems)){
        Object.assign(window.finalCartItems, {[prodId] : qty});
        this.checkQty(prodId, qty, window.limitedQtyProducts[prodId]);
      }
    }
    checkPurchaseLimit (prodId){
      const isLoading = async () => {
        return document.readyState === "complete"; }
      isLoading().then(r => {
        let
            isEmptyFinalCart =  Object.keys(window.finalCartItems).length === 0,
            inputQty = parseInt(document.querySelector(`[data-quantity-inp="${prodId}"]`).value) ;
        this.checkQty(prodId, inputQty, window.limitedQtyProducts[prodId]);
        (!(isEmptyFinalCart)) ? this.updateCartItems(prodId, inputQty) : Object.assign(window.finalCartItems,{[prodId] : inputQty});
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      if(window.enable_purchase_limit){
        let hasPurchaseLimitEnabled = this.parentNode.querySelector('.product-form__error-message-wrapper').hasAttribute('data-limit-message-wrapper');
        if(hasPurchaseLimitEnabled){
          let
              prodId =  parseInt(this.parentNode.querySelector('[data-limit-message-wrapper]').getAttribute('data-limit-message-wrapper')),
              maxQty =  window.limitedQtyProducts[prodId],
              qty = parseInt(document.querySelector(`[data-quantity-inp="${prodId}"]`).value),
              arrQty = window.finalCartItems[prodId];
          qty += arrQty;
          if(qty > maxQty){
            this.handleErrorMessage(`Quantity limit for this product is ${maxQty}. Please add A smaller value.`);
          }
          this.checkPurchaseLimit(prodId);
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
